const Header = () => {
    return (
        <header>
            <h1>Casper Jonker</h1>
            <h2>Full-stack Developer</h2>
        </header>
    )
}

export default Header
